import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from "@fluentui/react-components";
import { isLimitedOnlyUser, useUserRoleFlags } from "api/userRoleHeaders";
import { HorizontalSpacer } from "components/styled";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppStore } from "store/AppStore";
import { useRemindersCreateDialogStoreActions } from "store/RemindersCreateDialogStore";
import { useRemindersStoreState } from "store/RemindersStore";

const CreateReminderButton = () => {
  const { t } = useTranslation();

  const [{ updatedGrecoCompanies }] = useAppStore();

  const [{ taxonomy }] = useAppStore();
  const { searchClientsSelectedItem, searchPayersSelectedItem } =
    useRemindersStoreState();
  const { setRemindersCreateDialogStoreValues } =
    useRemindersCreateDialogStoreActions();
  // limited users (neither admin nor GOS) can only view reminders, not create them
  const canCreateReminder = !isLimitedOnlyUser(useUserRoleFlags());
  // group clientSaldo?.clientSaldoAmountAndCurrency list entities by companyNumber into companiesInfo map
  const companiesInfo = updatedGrecoCompanies?.filter((el) => el.selected);

  // when reminders are filtered by payer, the reminder is created by payer: the payer is fixed and clients are selected instead of payers
  const isPayerReminder = !searchClientsSelectedItem && !!searchPayersSelectedItem;
  const partySelectedItem = searchClientsSelectedItem ?? searchPayersSelectedItem;

  const openCreateReminderDialog = (companyNumber) => {
    setRemindersCreateDialogStoreValues({
      createReminderDialog: {
        isOpen: true,
        client: partySelectedItem,
        insuranceLineCode: null,
      },
      createReminderSort: null,
      clIsPayerReminder: isPayerReminder,
      clSearchPayersSelectedItem: partySelectedItem,
      clIsManualPayer: false,
      clPayerName: "",
      clGrecoCompanyNumbers: [companyNumber],
      clInsurersSelectedItem: [],
      clClientsSelectedItem: [],
      clPoliciesSelectedItem: [],
      clSubpoliciesSelectedItem: [],
      clServiceSegmentsSelectedItem: [],
      clCurrencyCodesSelectedItem: {
        value: taxonomy.Currency.byCode["Currency.EUR"].id,
        label: t(taxonomy.Currency.byCode["Currency.EUR"].code),
      },
      clFromDateFilter: moment().startOf("day").toDate(),
      clToDateFilter: moment().endOf("day").add(15, "days").toDate(),
      clComment: "",
      clReminderNumber: "",
      clIsBrokerPremiumCollection: true,
    });
    setTimeout(() => {
      document.querySelectorAll("input").forEach(function (element) {
        element.blur();
      });
    }, 50);
  };

  return (
    <>
      {canCreateReminder &&
      partySelectedItem &&
      Object.keys(companiesInfo).length > 0 ? (
        Object.keys(companiesInfo).length === 1 ? (
          <Button
            data-help="reminders-create-button"
            onClick={() => {
              openCreateReminderDialog(companiesInfo[0].companyNumber);
            }}
          >
            {t("pct.createReminder.label")}
          </Button>
        ) : (
          <>
            <Menu>
              <MenuTrigger disableButtonEnhancement>
                <Button data-help="reminders-create-button">
                  {t("pct.createReminder.label")}{" "}
                  {Object.keys(companiesInfo).length > 1
                    ? " (" + Object.keys(companiesInfo).length + ")"
                    : null}
                </Button>
              </MenuTrigger>

              <MenuPopover>
                <MenuList>
                  {/* iterate through companiesInfo keys */}
                  {companiesInfo.map((item) => {
                    return (
                      <MenuItem
                        key={item.companyNumber}
                        onClick={() => {
                          openCreateReminderDialog(item.companyNumber);
                        }}
                      >
                        {/* a company missing from the taxonomy falls back to its own short name, like the companies menu */}
                        {taxonomy?.Company.byId[item.companyNumber]
                          ? t(taxonomy.Company.byId[item.companyNumber].code)
                          : item.companyShort}
                      </MenuItem>
                    );
                  })}
                </MenuList>
              </MenuPopover>
            </Menu>

            <HorizontalSpacer width={10} />
          </>
        )
      ) : null}
    </>
  );
};
export default CreateReminderButton;
